import React from "react";
import { AdminDetailsObject } from "./adminDetailsObject";
import styles from "./createTeam.module.css";

interface AdminDetailsProps {
  adminDetails: AdminDetailsObject[];
}

const AdminRow: React.FC<AdminDetailsObject> = ({
  loginAlias,
  topLine,
  bottomLine,
}): JSX.Element => {
  return (
    <tr>
      <td>
        <div className={styles["hierarchy-headshot-cropper"]}>
          <img
            src={`https://badgephotos.corp.amazon.com/?uid=${loginAlias}`}
            alt="headshot"
            className={styles["hierarchy-headshot"]}
          />
        </div>
      </td>
      <td>
        <span className={styles["admin-details-top-line"]}>{topLine}</span>{" "}
        <br />
        <span className={styles["admin-details-bottom-line"]}>
          {bottomLine}
        </span>
      </td>
    </tr>
  );
};

const AdminDetails: React.FC<AdminDetailsProps> = ({
  adminDetails,
}): JSX.Element => {
  return (
    <table>
      <tbody>
        {adminDetails.map((admin) => (
          <AdminRow
            key={admin.loginAlias}
            loginAlias={admin.loginAlias}
            topLine={admin.topLine}
            bottomLine={admin.bottomLine}
          />
        ))}
      </tbody>
    </table>
  );
};

export default AdminDetails;
